import { Injectable } from '@angular/core';
import { Subject,BehaviorSubject } from 'rxjs';
import * as _ from 'underscore'

@Injectable()
export class EmitterService {

  activeGameInfo:any=null;

  constructor() { }

  private isKycBlockedSource = new BehaviorSubject<boolean>(true);
  isKycBlocked$ = this.isKycBlockedSource.asObservable();

  private logoutCompleteSource = new Subject<string>();
  logoutComplete$ = this.logoutCompleteSource.asObservable();

  private loginCompleteSource = new Subject<string>();
  loginComplete$ = this.loginCompleteSource.asObservable();

  private updateLoginStatus = new Subject<boolean>();
  updateLoginStatus$ = this.updateLoginStatus.asObservable();

  private countryBlockedSource = new Subject<string>();
  countryBlocked$ = this.countryBlockedSource.asObservable();

  private userDataSource = new Subject<string>();
  userDataSource$ = this.userDataSource.asObservable();

  private cancelPurchaseLoaderEvent = new Subject<number>();
  cancelPurchaseLoaderEvent$ = this.cancelPurchaseLoaderEvent.asObservable();

  private txnCompleteSource = new Subject<string>();
  txnComplete$ = this.txnCompleteSource.asObservable();

  private purchaseLoaderEvent = new Subject<number>();
  purchaseLoaderEvent$ = this.purchaseLoaderEvent.asObservable();

  private showSmallFooterEvent = new Subject<string>();
  showSmallFooterEvent$ = this.showSmallFooterEvent.asObservable();

  private enablePurchaseLoaderEvent = new Subject<number>();
  enablePurchaseLoaderEvent$ = this.enablePurchaseLoaderEvent.asObservable();

  private accordianClickEvent = new Subject<number>();
  accordianClickEvent$ = this.accordianClickEvent.asObservable();

  private profileCompletedSource = new Subject<string>();
  profileCompletedSource$ = this.profileCompletedSource.asObservable();

  private docUploadedEvent = new Subject<number>();
  docUploadedEvent$ = this.docUploadedEvent.asObservable();

  private backClickedInCashier = new Subject<string>();
  backClickedInCashier$ = this.backClickedInCashier.asObservable();

  private loadHomeBanner = new Subject<string>();
  loadHomeBanner$ = this.loadHomeBanner.asObservable();

  private paymentCompleteSource = new Subject<string>();
  paymentComplete$ = this.paymentCompleteSource.asObservable();

  private activeTabChangeSource = new Subject<string>();
  activeTabChange$ = this.activeTabChangeSource.asObservable();

  private headerTopicSource = new Subject<string>();
  headerTopicSource$ = this.headerTopicSource.asObservable();

  private modalCloseSource = new Subject<string>();
  modalClose$ = this.modalCloseSource.asObservable();

  private setLimitsSource = new Subject<string>();
  setLimitsSource$ = this.setLimitsSource.asObservable();

  private langCodeSource = new Subject<string>();
  langCodeSource$ = this.langCodeSource.asObservable();

  private getLangBasedResponse = new Subject<string>();
  getLangBasedResponse$ = this.getLangBasedResponse.asObservable();

  private accountStatusSource = new Subject<string>();
  accountStatusSource$ = this.accountStatusSource.asObservable();

  private accountPreferenceSource = new Subject<string>();
  accountPreferenceSource$ = this.accountPreferenceSource.asObservable();

  private accountPreferenceHeaderSource = new Subject<boolean>();
  accountPreferenceHeaderSource$ = this.accountPreferenceHeaderSource.asObservable();

  private currencySymbolSource = new BehaviorSubject<any>('');
  currencySymbolSource$ = this.currencySymbolSource.asObservable();

  private closeInactiveDropdownSource = new Subject<Object>();
  closeInactiveDropdownSource$ = this.closeInactiveDropdownSource.asObservable();

  private landingpageSource = new Subject<boolean>();
  landingpageSource$ = this.landingpageSource.asObservable();

  private registrationSteps = new Subject<string>();
  registrationSteps$ = this.registrationSteps.asObservable();

  private serverError = new Subject<any>();
  serverError$ = this.serverError.asObservable();

  private customServerError = new Subject<any>();
  customServerError$ = this.customServerError.asObservable();

  private sessionLimitTimerCompleted = new Subject<string>();
  sessionLimitTimerCompleted$ = this.sessionLimitTimerCompleted.asObservable();

  private depositLimitTimerCompleted = new Subject<string>();
  depositLimitTimerCompleted$ = this.depositLimitTimerCompleted.asObservable();

  private qDResponse = new Subject<any>();
  qDResponse$ = this.qDResponse.asObservable();

  private otpCompleted = new Subject<any>();
  otpCompleted$ = this.otpCompleted.asObservable();

  private notificationEvent = new Subject<any>();
  notificationEvent$ = this.notificationEvent.asObservable();

  private userCountry = new Subject<any>();
  userCountry$ = this.userCountry.asObservable();

  private setCountryCurrency = new Subject<any>();
  setCountryCurrency$ = this.setCountryCurrency.asObservable();

  private maintenanceemitter = new Subject<Boolean>();
  maintenanceemitter$ = this.maintenanceemitter.asObservable();

  private actionNotPermitter = new Subject<String>();
  actionNotPermitter$ = this.actionNotPermitter.asObservable();

  private allGamesemitter = new Subject<any>();
  allGamesemitter$ = this.allGamesemitter.asObservable();

  private loadTrustlyBanner = new Subject<String>();
  loadTrustlyBanner$ = this.loadTrustlyBanner.asObservable();

  private loadLogin = new Subject<String>();
  loadLogin$ = this.loadLogin.asObservable();

  private openMergeModal = new Subject<String>();
  openMergeModal$ = this.openMergeModal.asObservable();

  private loadTrustlyStep3 = new Subject<String>();
  loadTrustlyStep3$ = this.loadTrustlyStep3.asObservable();

  private liveCasinoTableIds =  new Subject<String>();
  liveCasinoTableIds$ = this.liveCasinoTableIds.asObservable();

  private liveCasinoTableData =  new Subject<String>();
  liveCasinoTableData$ = this.liveCasinoTableData.asObservable();

  private modalState = new Subject<any>();
  modalState$ = this.modalState.asObservable();

  private gameLaunchEmitter = new Subject<any>();
  gameLaunchEmitter$ = this.gameLaunchEmitter.asObservable();

  private statusCall = new Subject<any>();
  statusCall$ = this.statusCall.asObservable();

  private depositInitialised = new Subject<any>();
  depositInitialised$ = this.depositInitialised.asObservable();

  private checkUserProfileFlag = new Subject<any>();
  checkUserProfileFlag$ = this.checkUserProfileFlag.asObservable();

  private getSessionLimitFlag = new Subject<any>();
  getSessionLimitFlag$ = this.getSessionLimitFlag.asObservable();

  private abortStepOne = new Subject<boolean>();
  abortStepOne$ = this.abortStepOne.asObservable();

  private goToHomePage = new Subject<boolean>();
  goToHomePage$ = this.goToHomePage.asObservable();

  private isTrustlySite = new Subject<boolean>();
  isTrustlySite$ = this.isTrustlySite.asObservable();

  private gamesActiveTab = new Subject<String>();
  gamesActiveTab$ = this.gamesActiveTab.asObservable();

  private routeChangeState = new Subject<boolean>();
  routeChangeState$ = this.routeChangeState.asObservable();

  private isUserAccountLocked = new Subject<boolean>();
  isUserAccountLocked$ = this.isUserAccountLocked.asObservable();
  
  private isGameWindowMinimized = new Subject<any>();
  public isGameWindowMinimized$ = this.isGameWindowMinimized.asObservable();

  private isGamewindowLanuched = new Subject<any>();
  public isGamewindowLanuched$ = this.isGamewindowLanuched.asObservable();

  private updatedActiveGameInfo = new Subject<any>();
  public updatedActiveGameInfo$ = this.updatedActiveGameInfo.asObservable();

  isZimplerForm: any
  private UpdateIsZimplerForm = new BehaviorSubject<boolean>(false);
  public isZimplerForm$ = this.UpdateIsZimplerForm.asObservable();

  private isGameModal = new Subject<boolean>();
  isGameModal$ = this.isGameModal.asObservable();

  private updateMetaInfo = new Subject<any>();
  public updateMetaInfo$ = this.updateMetaInfo.asObservable();

  private toggleNavPanel = new Subject<any>();
  public toggleNavPanel$ = this.toggleNavPanel.asObservable();

  private myAccountActiveTabData = new Subject<any>();
  public myAccountActiveTabData$ = this.myAccountActiveTabData.asObservable();
  

  private showSearchBar = new Subject<any>();
  public showSearchBar$ = this.showSearchBar.asObservable();

  private isGameWindowInitialized = new Subject<boolean>();
  public isGameWindowInitialized$ = this.isGameWindowInitialized.asObservable();

  private showDepositNotification = new Subject<boolean>();
  public showDepositNotification$ = this.showDepositNotification.asObservable();

  private updateUserCountry = new Subject<boolean>();
  public updateUserCountry$ = this.updateUserCountry.asObservable();


  private upDatePendingWithdrawlCount = new Subject<boolean>();
  public upDatePendingWithdrawlCount$ = this.upDatePendingWithdrawlCount.asObservable();
  
  private emitSubmitFormClick = new Subject<boolean>();
  public emitSubmitFormClick$ = this.emitSubmitFormClick.asObservable();
  
  private showPreferenceFromNotificationBanner = new Subject<boolean>();
  public showPreferenceFromNotificationBanner$ = this.showPreferenceFromNotificationBanner.asObservable();
 
  private isGameWindowClosed = new Subject<any>();
  public isGameWindowClosed$ = this.isGameWindowClosed.asObservable();

  broadCastBannerPreferenceClick(status){
    this.showPreferenceFromNotificationBanner.next(status)
  }
  broadCastSubmitFormClick(status){
    this.emitSubmitFormClick.next(status)
  }
  broadPendingWithdrawlCount(status){
    this.upDatePendingWithdrawlCount.next(status)
  }

  broadCastUserCountryPNP(country){
    this.updateUserCountry.next(country)
  }
  private showLoginFailiedZimpler = new Subject<boolean>();
  public showLoginFailiedZimpler$ = this.showLoginFailiedZimpler.asObservable();

  broadCastLoginFailureZimpler(country){
    this.showLoginFailiedZimpler.next(country)
  }
  broadCastShowDepositNotification(status){
    this.showDepositNotification.next(status)
  }
  private depositeSuccess = new Subject<boolean>();
  public depositeSuccess$ = this.depositeSuccess.asObservable();

  broadCastIsZimplerForm(status){
    this.isZimplerForm = status
    this.UpdateIsZimplerForm.next(status)
  }

  private showRegModal = new Subject<boolean>();
  public showRegModal$ = this.showRegModal.asObservable();

  private openLeftNavPanelForFinland = new Subject<boolean>();
  public openLeftNavPanelForFinland$ = this.openLeftNavPanelForFinland.asObservable();


  private favouriteGames = new Subject<boolean>();
  public favouriteGames$ = this.favouriteGames.asObservable();

  private triggerQuickDeposit = new Subject<boolean>();
  public triggerQuickDeposit$ = this.triggerQuickDeposit.asObservable();

  private triggerInitializePayement = new Subject<boolean>();
  public triggerInitializePayement$ = this.triggerInitializePayement.asObservable();

  private emitWithdrawlFeesDetails = new Subject<boolean>();
  public emitWithdrawlFeesDetails$ = this.emitWithdrawlFeesDetails.asObservable();

  private triggerMoonpayDeposite = new Subject<boolean>();
  public triggerMoonpayDeposite$ = this.triggerMoonpayDeposite.asObservable();

  private showMoonpayPending = new Subject<boolean>();
  public showMoonpayPending$ = this.showMoonpayPending.asObservable();
  
  private updateBuyCryptoPayment = new Subject<boolean>();
  public updateBuyCryptoPayment$ = this.updateBuyCryptoPayment.asObservable();

  private sideMenuStatus = new Subject<boolean>();
  public sideMenuStatus$ = this.sideMenuStatus.asObservable();

  private openMyAccountPage = new Subject<boolean>();
  public openMyAccountPage$ = this.openMyAccountPage.asObservable();

  private cashierModalState = new Subject<boolean>();
  public cashierModalState$ = this.cashierModalState.asObservable();

  broadCastMyAccountPage(status){
    this.openMyAccountPage.next(status);
  }

  broadCastBuyCryptoPayment(status){
    this.updateBuyCryptoPayment.next(status)
  }
  private checkXSaleRegistration = new Subject<boolean>();
  public checkXSaleRegistration$ = this.checkXSaleRegistration.asObservable();

  broadCastXSaleRegistration(status){
    this.checkXSaleRegistration.next(status)
  }
  broadCastMoonpayClick(status){
    this.triggerMoonpayDeposite.next(status)
  }

  broadCastShowMoonpayPending(status){
    this.showMoonpayPending.next(status)
  }
 
  private showLeftCompleteProfile = new Subject<boolean>();
  public showLeftCompleteProfile$ = this.showLeftCompleteProfile.asObservable();
 

  broadCastShowRegModal(status){
    this.showRegModal.next(status)
  }
  broadCastLeftSideCompleteProfileShow(status){
    this.showLeftCompleteProfile.next(status)
  }

  broadCastOpenLeftNavPanelForFinland (status){
    this.openLeftNavPanelForFinland.next(status)
  }

  getIsZimplerForm(){
    return this.isZimplerForm
  }

  isCountryAllowed: any;
  private UpdateIsCountryAllowed = new BehaviorSubject<any>(null);
  public isCountryAllowed$ = this.UpdateIsCountryAllowed.asObservable();

  broadCastIsCountryAllowed(status){
    this.isCountryAllowed = status
    this.UpdateIsCountryAllowed.next(status)
  }

  getIsCountryAllowed(){
    return this.isCountryAllowed
  }

  broadCastIsGameLanuched(data) {
    this.isGamewindowLanuched.next(data);
  }

  broadCastGameWindowMinimized(flag: boolean) {
    this.isGameWindowMinimized.next(flag);
  }

  broadCastGameWindowClosed(flag: boolean) {
    this.isGameWindowClosed.next(flag);
  }

  broadcastRouteChange(state:boolean){
    this.routeChangeState.next(state);
  }
  
  broadcastIsUserAccountLocked(status: boolean) {
    this.isUserAccountLocked.next(status);
  }

  broadcastGamesActiveTab(activeTab:string){
    this.gamesActiveTab.next(activeTab);
  }

  broadcastIsKycBlocked(status: boolean) {
    this.isKycBlockedSource.next(status);
  }
  broadcastlogoutComplete(logoutStatus: string) {
    this.logoutCompleteSource.next(logoutStatus);
  }

  broadcastloginComplete(loginStatus: string) {
    this.loginCompleteSource.next(loginStatus);
  }

  broadcastLoginStatus(status: boolean) {
    this.updateLoginStatus.next(status);
  }

  broadcastCountryBlocked(blockedCOuntry: string) {
    this.countryBlockedSource.next(blockedCOuntry);
  }

  userDataSourceComplete(userDataStatus: any) {
    this.userDataSource.next(userDataStatus);
  }

  broadcastCanclePurchaseLoaderEvent(flag: any) {
    this.cancelPurchaseLoaderEvent.next(flag);
  }

  broadcasttxnComplete(txnStatus: string) {
    this.txnCompleteSource.next(txnStatus);
  }

  broadcastPurchaseLoaderEvent(flag: any) {
    this.purchaseLoaderEvent.next(flag);
  }

  broadcastShowSmallFooterEvent(flag: any) {
    this.showSmallFooterEvent.next(flag);
  }

  broadcastEnablePurchaseLoaderEvent(flag: any) {
    this.enablePurchaseLoaderEvent.next(flag);
  }

  broadcastAccordianClickEvent(flag: any) {
    this.accordianClickEvent.next(flag);
  }
  broadcastProfileCompletedSource(profileCompletedStatus: string) {
    this.profileCompletedSource.next(profileCompletedStatus);
  }

  broadcastdocUploadedEvent(flag: any) {
    this.docUploadedEvent.next(flag);
  }

  broadcastbackClickedInCashier(flag: any) {
    this.backClickedInCashier.next(flag);
  }

  broadcastLoadHomeBanner(status: string) {
    this.loadHomeBanner.next(status);
  }

  broadcastpaymentComplete(paymentStatus: string) {
    this.paymentCompleteSource.next(paymentStatus);
  }

  broadcastActiveTabChangeSource(activeTab: string) {
    this.activeTabChangeSource.next(activeTab);
  }

  broadcastHeaderTopicSource(activeTab: string) {
    this.headerTopicSource.next(activeTab);
  }

  broadcastModalChangeSource() {
    this.modalCloseSource.next("");
  }

  broadcastsetLimits(routeUrl: any) {
    this.setLimitsSource.next(routeUrl);
  }

  broadcastLangCode(langCode: string) {
    this.langCodeSource.next(langCode);
  }

  broadcastGetLangBasedResponse(any) {
    this.getLangBasedResponse.next(any);
  }

  broadcastAccountStatus(langCode: string) {
    this.accountStatusSource.next(langCode);
  }

  broadcastAccountPreference(langCode: string) {
    this.accountPreferenceSource.next(langCode);
  }

  broadcastAccountPreferenceHeaderSource(showHeader: boolean) {
    this.accountPreferenceHeaderSource.next(showHeader);
  }

  broadcurrencySymbolSourceSource(symbol: string) {
    this.currencySymbolSource.next(symbol);
  }

  broadcastcloseInactiveDropdown(dropdownState:Object) {
    this.closeInactiveDropdownSource.next(dropdownState);
  }

  broadcastLandingpage(status:boolean){
    this.landingpageSource.next(status);
  }

  broadcastregistrationSteps(registrationStatus: string) {
    this.registrationSteps.next(registrationStatus);
  }

  broadcastserverError(statusErrors: any, url: any) {
    this.serverError.next({ statusErrors: statusErrors, url: url });
  }

  broadcastCustomServerError(statusErrors) {
    this.customServerError.next(statusErrors);
  }

  broadcastSessionLimitTimerCompleted(sessionLimit: string) {
    this.sessionLimitTimerCompleted.next(sessionLimit);
  }


  broadcastDepositLimitTimerCompleted(depositLimit: string) {
    this.depositLimitTimerCompleted.next(depositLimit);
  }

  broadcastqDResponse(resp) {
    this.qDResponse.next(resp);
  }

  broadcastOTPcomplete() {
    this.otpCompleted.next("");
  }

  broadCastnotificationEvent(resp) {
    this.notificationEvent.next(resp);
  }

  broadCastUserCountry(country) {
    this.userCountry.next(country);
  }

  broadcastsetCountryCurrency(country) {
    this.setCountryCurrency.next(country);
  }

  broadcastMaintenanceEmitter(status: boolean) {
    this.maintenanceemitter.next(status);
  }

  broadcastActionNotPermitter(status: string) {
    this.actionNotPermitter.next(status);
  }

  broadcastAllGamesEmitter(gameId:String) {
    this.allGamesemitter.next(gameId);
  }

  broadcastLoadTrustlyBanner(status: String) {
    this.loadTrustlyBanner.next(status);
  }

  broadcastLoadLogin() {
    this.loadLogin.next("");
  }

  broadcastOpenMergeModal() {
    this.openMergeModal.next("");
  }

  broadcastLoadTrustlyStep3() {
    this.loadTrustlyStep3.next("");
  }

  broadcastLiveCasinoTableIds(tableId:any) {
    this.liveCasinoTableIds.next(tableId);
  }

  broadcastLiveCasinoTableData(tableData:any) {
    this.liveCasinoTableData.next(tableData);
  }

  broadcastModalState(options: any) {
    this.modalState.next(options);
  }

  broadcastgameLaunchEmitter(any) {
    this.gameLaunchEmitter.next(any);
  }

  broadcastStatusCall(any) {
    this.statusCall.next(any);
  }

  broadcastdepositInitialisedCall(any) {
    this.depositInitialised.next(any);
  }

  broadcastCheckUserProfileFlag(any="") {
    this.checkUserProfileFlag.next(any);
  }

  broadcastGetSessionLimitFlag(any="") {
    this.getSessionLimitFlag.next(any);
  }

  broadcastAbortStepOne(status: boolean) {
    this.abortStepOne.next(status);
  }

  broadcastGoToHomePage(status: boolean) {
    this.goToHomePage.next(status);
  }

  broadcastIsTrustlySite(status: boolean) {
    this.isTrustlySite.next(status);
  }

  broadCastIsGameModal (status: boolean) {
    this.isGameModal.next(status);
  }

  broadCastUpdateMetaInfo(any) {
    this.updateMetaInfo.next(any);
  }

  broadCastUpdatedActiveGameInfo(any) {
    this.updatedActiveGameInfo.next(any);
  }

  broadCastToggleNavPanel(any) {
    this.toggleNavPanel.next(any);
  }
  
  broadCastMyAccountActiveTabData(any) {
    this.myAccountActiveTabData.next(any);
  }

  broadCastShowSearchBar(boolean) {
    this.showSearchBar.next(boolean);
  }

  broadCastIsGameWindowInitialized(status: boolean) {
    this.isGameWindowInitialized.next(status);
  }
  
  broadCastFavouriteGames(boolean) {
    this.favouriteGames.next(boolean);
  }

  private withdrwalSuccessMsg = new Subject<boolean>();
  public withdrwalSuccessMsg$ = this.withdrwalSuccessMsg.asObservable();
  

  broadCastWithdrwalSuccessMsg(flag){
    this.withdrwalSuccessMsg.next(flag)
  }

  boradCastQuickDeposit(){
    this.triggerQuickDeposit.next(true);
  }
  broadCastInitializePayment(){
    this.triggerInitializePayement.next(true);
  }
  broadCastWithdrawlFeesDetails(boolean){
    this.emitWithdrawlFeesDetails.next(boolean);
  }

  broadCastDepositeSuccess(status){
    this.depositeSuccess.next(status);
  }

  broadCastSideMenuStatus(status){
  this.sideMenuStatus.next(status)
  }

  private emitSortUpdateCallForLobbies = new Subject<boolean>();
  public emitSortUpdateCallForLobbies$ = this.emitSortUpdateCallForLobbies.asObservable();

  broadCastSortUpdate(status){
    this.emitSortUpdateCallForLobbies.next(status);
  }

  private updateBonusDetails = new Subject<boolean>();
  public updateBonusDetails$ = this.updateBonusDetails.asObservable();

  broadCastUpdateBonusDetails(status){
    this.updateBonusDetails.next(status);
  }

  broadCastCashierModalState(status){
    this.cashierModalState.next(status);
  }


  private onChangePaymentMethod = new Subject<boolean>();
  public onChangePaymentMethod$ = this.onChangePaymentMethod.asObservable();

  private isFormValidationEnabled = new Subject<boolean>();
  public isFormValidationEnabled$ = this.isFormValidationEnabled.asObservable();

  private showDepositSuccessNotification = new Subject<boolean>();
  public showDepositSuccessNotification$ = this.showDepositSuccessNotification.asObservable();

  private toggleCashierPageChange = new Subject<string>();
  public toggleCashierPageChange$ = this.toggleCashierPageChange.asObservable();

  private showTransactionStatus = new Subject<boolean>();
  public showTransactionStatus$ = this.showTransactionStatus.asObservable();

  private logoutAndLoginStatusUpdate = new Subject<any>();
  public logoutAndLoginStatusUpdate$ = this.logoutAndLoginStatusUpdate.asObservable();

  private cashierInputConfigData = new Subject<boolean>();
  public cashierInputConfigData$ = this.cashierInputConfigData.asObservable();

  private updateAmountInTransactionBreakdown = new Subject<boolean>();
  public updateAmountInTransactionBreakdown$ = this.updateAmountInTransactionBreakdown.asObservable();

  private customerCashierTransactionStatusChange = new Subject<boolean>();
  public customerCashierTransactionStatusChange$ = this.customerCashierTransactionStatusChange.asObservable();

  private finalizeCashierTransactionStatus = new Subject<boolean>();
  public finalizeCashierTransactionStatus$ = this.finalizeCashierTransactionStatus.asObservable();

  private toggleCashierLoader = new Subject<boolean>();
  public toggleCashierLoader$ = this.toggleCashierLoader.asObservable();

  private customCashierPage = new Subject<boolean>();
  public customCashierPage$ = this.customCashierPage.asObservable();

  private addNewCardClick = new Subject<boolean>();
  public addNewCardClick$ = this.addNewCardClick.asObservable();

  private updateCashierFormData = new Subject<boolean>();
  public updateCashierFormData$ = this.updateCashierFormData.asObservable();
  private clearePromotionData = new Subject<boolean>();
  public clearePromotionData$ = this.clearePromotionData.asObservable();
  //we are emiting languages for promotion module
  private activeLanguages = new BehaviorSubject<[]>([]);
  public activeLanguages$ = this.activeLanguages.asObservable();

  broadCastCashierLoader(status){
    this.toggleCashierLoader.next(status)
  }

  broadCastfinalizeCashierTransactionStatus(status){
    this.finalizeCashierTransactionStatus.next(status);
  }
  broadCastCustomerCashierTransactionStatusChange(status){
    this.customerCashierTransactionStatusChange.next(status);
  }
  broadCastAmountInTransactionBreakdown(status){
    this.updateAmountInTransactionBreakdown.next(status);
  }
  broadCastCashierInputConfigData(status){
    this.cashierInputConfigData.next(status);
  }
  broadCastLogoutAndLoginStatus(status){
    this.logoutAndLoginStatusUpdate.next(status);
  }

  broadCastTransactionStatus(status){
   this.showTransactionStatus.next(status);
  }
  boradCastCahsierPageChange(status){
    this.toggleCashierPageChange.next(status);
  }
  broadCastPaymentMethod(status){
   this.onChangePaymentMethod.next(status);
  }
  broadCastFormValidationStatus(status){
   this.isFormValidationEnabled.next(status);
  }
  broadCastSuccessNotifcationStatus(status){
    this.showDepositSuccessNotification.next(status);
  }
  broadCastCustomCashierPage(status){
    this.customCashierPage.next(status);
  }
  broadCastAddNewCardClick(status){
    this.addNewCardClick.next(status);
  }
  broadCastCreditCardFormData(form){
    this.updateCashierFormData.next(form);
  }

  //static page API call
  private staticPageApiResponse = new Subject<string>();
  staticPageApiResponse$ = this.staticPageApiResponse.asObservable();

  broadCastStaticPageResponse(status){
    this.staticPageApiResponse.next(status);
  }
  broadCastPromotionsDataClear(status){
    this.clearePromotionData.next(status);
  }

  private gamesHistoryList = [];
  private latestGame;
  private openedGame = new Subject<any>();
  public openedGame$ = this.openedGame.asObservable();

  broadcastOpenedGames(gameId, gameLaunchUrlPath){
    let gameObj = {gameId:gameId,gameLaunchUrlPath:gameLaunchUrlPath}
    this.gamesHistoryList.push(gameObj)
    this.openedGame.next(gameObj);
    this.latestGame = gameObj;
  }

  getGamesHistoryList(){
    this.gamesHistoryList = _.unique(this.gamesHistoryList, false, obj => obj.gameId)
    return this.gamesHistoryList;
  }

  broadcastActiveLanguages(langs){
    this.activeLanguages.next(langs)
  }

  getLatestgame(){
    return this.latestGame
  }
  
  /**
   * Emitters to Emit the correct footer license value based on the selected jurisdiction.
   */
  private jurisdictionValue = new BehaviorSubject<string | null>(null);
  jurisdictionValue$ = this.jurisdictionValue.asObservable();

  broadCastJurisdictionValue(status: string) {
    this.jurisdictionValue.next(status);
  }
  
  private prevJurisdictionValue = new BehaviorSubject<string | null>(null);
  prevJurisdictionValue$ = this.prevJurisdictionValue.asObservable();

  broadCastPrevJurisdictionValue(status: string) {
    this.prevJurisdictionValue.next(status);
  }

  private toggleLabelForSweden = new Subject<boolean>();
  public toggleLabelForSweden$ = this.toggleLabelForSweden.asObservable();

  broadcastSwedenlableForPhoneNumer(status){
    this.toggleLabelForSweden.next(status)
  }
}




